<template>
  <component
    :is="getQuickLinksComponent"
    :title="`${t('W.qLinks')}`"
    :classes="['bto-sb-widget-quick-links']">
    <ul>
      <li v-for="(item, idx) in links" :key="idx">
        <span class="bto-sb-quick-links-icon" v-if="item.imgUrl">
          <img :src="`${item.imgUrl}`" :alt="item.label" />
        </span>
        <span class="bto-sb-quick-links-item">
          <component :is="item.component" v-bind="item.props">{{ item.label }}</component>
        </span>
      </li>
    </ul>
  </component>
</template>

<script>
  import Accordion from '../../shared/accordion';
  import ItemList from '../../shared/item-list.vue';
  import { getLinkProps, getQuickLinks, quickLinksStore } from '@bto-services/quick-links';

  export default {
    name: 'QuickLinksWidget',
    data() {
      return {
        expanded: true,
      };
    },
    props: {
      quickLinks: {
        fieldType: 'link-repeater',
        label: 'Add Link',
        hasIcons: true,
        default: () => [
          {
            applied: true,
            editmode: false,
            iconUrl: '',
            label: '',
            link: '#',
            target: '_self',
          },
        ],
      },
      getLinksFromSB: {
        type: Boolean,
        default: false,
        label: 'Get links from SB',
        description: 'Flag to get quick links from SB Admin',
      },
    },
    methods: {
      toggleWidget() {
        this.expanded = !this.expanded;
      },
    },
    components: {
      Accordion,
      ItemList
    },
    computed: {
      getQuickLinksComponent() {
        if (APP_SETTINGS.settings.layout === 'US') {
          return ItemList;
        }
        return Accordion;
      },
      links() {
        if (this.getLinksFromSB) {
          return quickLinksStore.value.links;
        }
        return this.quickLinks.map(ql => getLinkProps(ql));
      },
    },
    created() {
      if (this.getLinksFromSB) {
        getQuickLinks();
      }
    },
  };
</script>
